import validator from 'validator'
import { t } from 'i18next'

export const isUrl = (value: unknown): true | string => {
  if (!value || typeof value !== 'string') return true

  const options = {
    protocols: ['http', 'https'],
    require_tld: true,
    require_host: true,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
  }

  return validator.isURL(value, options) ? true : t('page.candidateDetails.form.errors.notUrl')
}
